<template>
    <b-overlay :show="loadProcessing>0" z-index="2147483647" style="height: 100%"
               opacity="0.02" variant="white"
    >
        <div class="tools-container no-print">
            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>
            <b-button variant="primary" @click="btnPrintClicked">Печать</b-button>
            <b-button variant="secondary" @click="btnCloseClicked" class="ml-2">Закрыть</b-button>
        </div>

        <div class="parent-container">
            <div class="ml-1">
                <p class="font-weight-bolder font-size-sm mb-0">Паспорт № {{recordIdentity}}</p>
            </div>
            <div class="mt-1">
                <img :src="getImgLink()" width="70" height="70" class="float-left d-block"/>
            </div>
            <div class="ml-1 clear-fix">
                <p class="font-weight-bolder font-size-sm mb-0">{{deviceNum}}</p>
            </div>
        </div>

    </b-overlay>
</template>

<script>
    import axios from "axios";

    export default {
        name: "BlankRPDeviceRegisterJournalQRCode",
        data() {
            return {
                userData: this.$store.getters.getUserData,
                loadProcessing: 0,

                err: false,
                errText: "",
                errVariant: "danger",

                sessionUid: "",
                recordUid: "",

                recordIdentity: 0,
                dtShort: "",
                deviceNum: ""
            }
        },
        created() {
            document.title = "ЭЦОН - Печать QR-кода"

            this.sessionUid = this.$route.query.sessionUid || ""
            this.recordUid = this.$route.query.recordUid || ""
        },
        mounted() {
            this.loadData()
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadData() {
                this.loadProcessing++
                axios.post("/ws/ws.svc/GetDocsBlankInfo", {
                        'Session_UID': this.sessionUid,
                        'F_DocBlank_UID': 3,
                        'F_Language_UID': 0,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(result)) {
                                        this.recordIdentity = result.RecordIdentity || 0
                                        this.deviceNum = result.DeviceNum.toString() || ""
                                    } else {
                                        this.errTextShow(resp.data.response.toString(), "danger", true)
                                    }
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            btnPrintClicked() {
                window.print()
            },
            btnCloseClicked() {
                window.close()
            },
            getImgLink() {
                return `ws/blankqrcode?session_uid=${this.sessionUid}&docblank_uid=3&uid=${this.recordUid}&l=0`
            }
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>
    .tools-container {
        margin: 20px auto 0 auto;
        width: 900px;
    }

    .parent-container {
        background-color: #fff;
        margin: 20px auto;
        padding: 20px 20px 20px 20px;
        width: 900px;
        min-height: 500px;
        /*height: 1273px;*/
        font-family: "Calibri", "Helvetica", "sans-serif";
        font-size: 11pt !important;
    }

    .clear-fix {
        clear: both;
    }

    @media print {
        @page {
            size: A4;
            margin: 0;
            font-family: "Calibri", "Helvetica", "sans-serif";
            color: #000 !important;
        }

        .parent-container {
            width: 100%;
            padding: 0 20px 0 20px;
        }

        .no-print {
            display: none;
        }
    }
</style>